/**
 * O MESMO mecanismo de `cartao-campos-reuniao-desfecho-externo.js` (ver o
 * cabeçalho de lá para o histórico completo do achado — G-17/G-21, spec-010-
 * r2-guiada-pelo-agente-com-transcricao), agora para `fee-fixo/envio-
 * relatorio` — [G-4] do QA da rodada-v5 (09/09/2026, achado da team-lead).
 *
 * `preparar_envio_relatorio_fee_fixo` virou escrita two-step com commit no
 * SERVIDOR (ver `ia/adaptadores.js::propsDoEnvioDeRelatorio`). Medido no app
 * real: o desfecho (enviado/erro/descartado) chega em OUTRO `tool_call`
 * (`servidor-confirmacao-<uuid>`/`protocolo-<uuid>`), com o MESMO
 * `preview_id` — o cartão de PREVIEW nunca recebe esse estado na PRÓPRIA
 * parte. Sem esta correlação, o cartão de origem ficava preso no PREVIEW com
 * "Cancelar"/"Enviar relatório" habilitados ao lado do cartão de desfecho já
 * resolvido — dois cartões do MESMO `preview_id`, um dizendo o fato e o
 * outro ainda oferecendo a ação.
 *
 * A varredura (`mensagensDaSuperficie`/`propsDoDesfechoExterno` — as três
 * superfícies de chat conhecidas + a busca por `tool_calls[]` resolvido) é a
 * MESMA de `cartao-campos-reuniao` — vive em `desfecho-externo-por-
 * preview.js`, e não é duplicada aqui.
 *
 * Sem `?.`/`??` (o Babel deste projeto não transpila). Acentos UTF-8 reais.
 */
import { CHAVES } from '@modules/fee-fixo/ia/registry'
import { RESOLVIDO_POR_ESTADO } from '@modules/fee-fixo/ia/adaptadores'
import {
  mensagensDaSuperficie,
  propsDoDesfechoExterno,
} from '@modules/fee-fixo/ia/cartoes/desfecho-externo-por-preview'

export { mensagensDaSuperficie }

/**
 * O `resolvido` (`'enviado'|'erro'|'cancelado'`) que OUTRA mensagem já
 * publicou para este `previewId` — ou `''` sem match (o mesmo default do
 * próprio prop `resolvido` do cartão, fail-closed: sem `previewId`, nenhuma
 * correlação é possível). `RESOLVIDO_POR_ESTADO` é IMPORTADO de
 * `ia/adaptadores.js`: é a MESMA tradução `estado → resolvido` que o
 * adaptador já aplica ao payload PRÓPRIO deste cartão.
 */
export function resolvidoExternoDoPreview(mensagens, previewId) {
  const props = propsDoDesfechoExterno(
    mensagens,
    previewId,
    CHAVES.ENVIO_RELATORIO
  )
  if (props === null) return ''
  return RESOLVIDO_POR_ESTADO[props.estado] || ''
}
